<template>
<div>
    <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
        <sav-spinner v-if="loading" :size="10" />
        <template v-if="!loading && selected">
            <template v-if="selected.found">
                <h1 class="text-xl font-bold">
                    <i class="mr-1 text-green-600 fas fa-check-circle"></i> {{$t('form.find-ticket.justificatif_d_achat_identifie')}}
                </h1>
                <h3 class="font-light">{{$t('form.find-ticket.nous_avons_pu_identifier_votre_justificatif_d_achat')}}</h3>
            </template>
            <template v-if="!selected.found">
                <h1 class="text-xl font-bold">
                    <i class="mr-1 text-red-600 fas fa-times"></i> {{$t('form.find-ticket.justificatif_d_achat_introuvable')}}
                </h1>
                <h3 class="font-light">{{$t('form.find-ticket.nous_n_avons_pas_pu_identifier_votre_justificatif_d_achat')}}</h3>
            </template>
        </template>
    </div>
</div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'
import apiService from '@/services/api.service'

export default {
    name: 'find-ticket',
    extends: FormCardExtension,

    methods: {
        async init() {
            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.getNextRoute()
                return
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            this.loading = true
            let response = await apiService.post('ticket', {
                purchase_date: this.$formTool.getFormData('purchase-date')[0].value,
                code_caisse: this.$formTool.getFormData('code-caisse')[0].value,
                num_facture: this.$formTool.getFormData('sales-receipt')[0].value,
                code_magasin: this.$formTool.getFormData('shop')[0].value.code_mag
            })
            this.data = response.data.posts.post
            this.loading = false

            if (this.data) {
                if (!(this.data instanceof Array)) {
                    let dataCopy = {...this.data}
                    this.data = []
                    for (let indexData in dataCopy) {
                        if (dataCopy[indexData].ean) {
                            this.data.push(dataCopy[indexData])
                        }
                    }
                }
                this.end({products: [...this.data], found: true})
            } else {
                this.end({found: false})
            }
        },

        end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
            this.nextBlock = this.getNextRoute()
        },

        getNextRoute() {
            if (this.selected && this.selected.found) {
                return this.$formTool.blockData(this.$options.name).next.found
            } else {
                return this.$formTool.blockData(this.$options.name).next.notFound
            }
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/shop/FindTicketCard.vue